import * as React from 'react';

interface AttributeValuesListProps {
    attributeValues: any[] | null;
}

export const AttributeValuesList: React.FC<AttributeValuesListProps> = ({
    attributeValues,
}) => {
    return attributeValues ? (
        <div className="attribute-values-list">
            <ul>
                {attributeValues.map((value, index) => (
                    <li key={index}>
                        <span>{value ? value : 'null'}</span>
                    </li>
                ))}
            </ul>
            {attributeValues.length === 10 && (
                <div className="more-values">And more values…</div>
            )}
        </div>
    ) : null;
};
